import { Component, Directive, ElementRef, Host, HostListener, Input, SkipSelf } from '@angular/core';

@Component({
    selector: '[resizable]',
    templateUrl: './resizer.component.html',
    styleUrls: ['./resizer.component.css'],
    standalone: false
})
export class ResizableComponent {

  private resizableElement: HTMLElement;
  private width: number = 0;
  public isDragging: boolean = false;

  @Input('resizable') isResizable: boolean = false;

  constructor(private element: ElementRef) {
    this.resizableElement = element.nativeElement;
  }

  public start(): void {
    this.isDragging = true;
    this.width = this.resizableElement.clientWidth;
  }

  public drag(diff: number): void {
    this.resizableElement.style.width = this.width + diff + "px";
  }

  public stop(): void {
    this.isDragging = false;
    this.width = 0;
    window.dispatchEvent(new Event('resize'));
  }

}
@Directive({
    selector: '[resizable-divider]',
    standalone: false
})
export class ResizableDividerComponent {

  private startPosition: number = 0;
  private isDragging: boolean = false;

  constructor(@Host() @SkipSelf() private resizable: ResizableComponent) {
  }

  @HostListener('mousedown', ['$event']) onMouseDown = (e: MouseEvent) => {
    e.preventDefault();
    this.isDragging = true;
    this.startPosition = e.clientX;
    this.resizable.start();
  }

  @HostListener('document:mouseup', ['$event']) onMouseUp = (e: MouseEvent) => {
    e.preventDefault();
    this.isDragging = false;
    this.resizable.stop();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      event.preventDefault();
      let pos = event.clientX - this.startPosition;
      this.resizable.drag(pos);
    }
  }
}
